import { Component, OnInit, AfterViewInit, OnDestroy, Input, ElementRef, NgZone, ViewChild } from '@angular/core';
import { GeocodingService } from 'src/app/core/services/geocoding.service';
import { NgForm } from '@angular/forms';
import { Observable, from } from 'rxjs';
import { StateService } from '@uirouter/angular';
import { AuthService } from 'src/app/core/services/auth.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UserService } from 'src/app/core/services/user.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { EmployeeService } from 'src/app/core/services/employee.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AddEditUserActionsModalService } from 'src/app/core/services/add-edit-user-actions-modal.service';
import { UibModalService } from 'src/app/core/services/uibModalService';
import { MESSAGECONSTANTS, USERMANAGEMENTCONSTANTS } from 'src/app/core/utils/constants';

declare var $: any;

@Component({
  selector: 'app-add-edit-user-page',
  templateUrl: './add-edit-user-page.component.html',
  styleUrls: ['./add-edit-user-page.component.css']
})
export class AddEditUserPageComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() $transition$: any;
  @ViewChild('userDetailsForm') userDetailsForm: NgForm;
  @ViewChild('userScopeDetailsForm') userScopeDetailsForm: NgForm;

  MESSAGECONSTANTS: any = MESSAGECONSTANTS;
  USERMANAGEMENTCONSTANTS: any = USERMANAGEMENTCONSTANTS;

  stateParams: any;
  accessMode: any;
  managerDetails: any;
  userProfile: any = { userDetails: { role: {} }, userScopeDetails: {}, userForwardRecipientDetails: {} };
  userProfileReset: any = { userDetails: {} };
  userObject: any;
  originalManagerObj: any;

  companyType: any;
  companyId: any;
  isCorporateFlag: boolean;
  isInHost: boolean;
  isStaffingCompany: boolean;
  isCorporateCompany: boolean;

  roles: Array<any> = [];
  buList: Array<any> = [];
  clientOrBUList: Array<any> = [];
  managerList: Array<any> = [];
  selectedDepartmentObjectsArray: Array<any> = [];
  selectedBuName: any;

  geoLocations: Array<any> = [];
  geoLocationsCopy: Array<any> = [];
  validzipcode: boolean;
  isCountyExists = false;

  isValidWorkTelephoneEntered = false;
  isValidMobileNumberEntered = false;
  workTelephoneFormat: any = '';
  mobileNumberFormat: any = '';

  canAddUserAtCompanyLevel = false;
  canAddUserAtDepartmentOrBULevel = false;
  editProfileEnabled = false;
  isLoading = true;

  showClientList = false;
  showBuList = false;
  roleChanged = false;
  managerChanged = false;
  oldRole: any;
  oldManager: any;

  formSubmitted = false;
  nextButtonClicked = false;
  saveButtonClicked = false;
  valid = false;
  lastStep = false;
  isTransitionAbortRequired = true;
  userCreated = false;
  nextButtonFlag = 0;
  saveButtonFlag = 0;
  recentButtonClick: string;

  private wizardEl: any;
  private wizardAdvancePending = false;

  constructor(
    private authService: AuthService,
    private storageService: StorageService,
    private userService: UserService,
    private utilityService: UtilityService,
    private companyService: CompanyService,
    private userRoleService: UserRoleService,
    private employeeService: EmployeeService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private addEditUserActionsModalService: AddEditUserActionsModalService,
    private uibModalService: UibModalService,
    private geocodingService: GeocodingService,
    private elementRef: ElementRef,
    private ngZone: NgZone,
    public $state: StateService
  ) { }

  ngOnInit() {
    this.stateParams = this.$transition$.params();
    this.companyType = this.authService.getUserDetails().company.companyType;
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.isCorporateFlag = (this.authService.getUserDetails().company.companyType === 'Corporation');
    this.isInHost = this.utilityService.isInHost();
    this.isStaffingCompany = this.companyService.isStaffingCompany();
    this.isCorporateCompany = this.companyService.isCorporateCompany();
    this.accessMode = this.stateParams.accessMode;
    this.managerDetails = this.stateParams.manager;

    if (this._isCreateUserUnderManager()) {
      this.isLoading = false;
      if (this.managerDetails != null && this.managerDetails.lastName != null) {
        this.managerDetails.firstName = this.managerDetails.firstName + ' ' + this.managerDetails.lastName;
      }
      this.storageService.set('useraccessmode', this.accessMode, null);
      this.storageService.remove('userProfile');
      this.storageService.set('manager', this.managerDetails, null);
      this.userProfile.departmentId = null;
      this.userProfile.departmentName = null;
      this.userProfile.buId = null;
      this.userProfile.buName = null;
      this.userProfile.isPointOfContact = false;
      this.userProfileReset = _.cloneDeep(this.userProfile);
      this.userService.getUserRoleEntityScopeById(this.managerDetails.userId, this.companyId, this.managerDetails.roleId, (data) => {
        this.clientOrBUList = data.clientOrBUList;
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
      this._getUserBelongsTo();
      this._getRolesInTheCompany();
      this._setDepartment();
    } else if (this._isEditOrViewUser()) {
      this._getUserProfileInfo(() => {
        this.isLoading = false;
        this.isValidMobileNumberEntered = true;
        this.isValidWorkTelephoneEntered = true;
        setTimeout(() => {
          this._getAddressDetails(this.userObject.userDetails.zipcode, 'start', () => {
            this.geoLocationsCopy = _.cloneDeep(this.geoLocations);
          });
        }, 500);
        this.storageService.set('useraccessmode', this.accessMode, null);
        this.storageService.remove('manager');
        this.storageService.set('userProfile', _.cloneDeep(this.userObject), null);
        this.userProfile = _.cloneDeep(this.userObject);
        if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
          this._populateForwardRecipientForView();
          this.originalManagerObj = _.cloneDeep(this.userProfile.userDetails.manager);
          if (this.originalManagerObj != null && this.originalManagerObj.lastName != null) {
            this.originalManagerObj.firstName = this.originalManagerObj.firstName.split(' ')[0];
          }
        } else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
          if (this.userProfile.userDetails.userId === this.authService.getUserDetails().id) {
            this.editProfileEnabled = true;
          }
          this.originalManagerObj = _.cloneDeep(this.userProfile.userDetails.manager);
          if (this.originalManagerObj != null && this.originalManagerObj.lastName != null) {
            this.originalManagerObj.firstName = this.originalManagerObj.firstName.split(' ')[0];
          }
        }
        this.userProfileReset = _.cloneDeep(this.userProfile);
        this.userService.getUserRoleEntityScopeById(this.userProfile.userDetails.userId, this.companyId, this.userProfile.userDetails.role.id, (data) => {
          this.clientOrBUList = data.clientOrBUList;
        }, (error) => {
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
        this._getUserBelongsTo();
        this._getRolesInTheCompany();
        this._setDepartment();
      });
    } else {
      const useraccessmode = this.storageService.get('useraccessmode');
      const userProfile = this.storageService.get('userProfile');
      const manager = this.storageService.get('manager');
      if (manager !== null && useraccessmode !== null && userProfile === null) {
        this.managerDetails = manager;
        this.accessMode = useraccessmode;
        this.userProfileReset = _.cloneDeep(this.userProfile);
      } else if (userProfile !== null && useraccessmode !== null && manager === null) {
        this.userProfile = userProfile;
        this.accessMode = useraccessmode;
        this.storageService.remove('manager');
        this.userProfileReset = _.cloneDeep(this.userProfile);
      } else {
        console.log('objects are not there both in storage and stateparams');
      }
      this._getRolesInTheCompany();
      this._setDepartment();
    }

    if (this.userRoleService.isLoggedInUserAnAdmin()) {
      this.canAddUserAtCompanyLevel = true;
      this.canAddUserAtDepartmentOrBULevel = true;
    } else if (!this.isCorporateFlag) {
      this.canAddUserAtCompanyLevel = true;
      this.canAddUserAtDepartmentOrBULevel = true;
    }
  }

  ngAfterViewInit() {
    // the wizard container stays in the DOM ([hidden], not *ngIf) so fuelux can
    // take it over here even though isLoading flips to false asynchronously later
    setTimeout(() => {
      this.wizardEl = $(this.elementRef.nativeElement).find('#addEditUserWizard');
      this.wizardEl.wizard();
      this.wizardEl.on('actionclicked.fu.wizard', (evt, data) => {
        this.ngZone.run(() => this._onWizardActionClicked(evt, data));
      });
      this.wizardEl.on('finished.fu.wizard', () => {
        this.ngZone.run(() => this._onWizardFinished());
      });
    });
  }

  ngOnDestroy() {
    if (this.wizardEl) {
      this.wizardEl.off('actionclicked.fu.wizard finished.fu.wizard');
    }
  }

  private _isCreateUserUnderManager() {
    return this.stateParams.manager !== null && this.stateParams.accessMode === 'create';
  }

  private _isEditOrViewUser() {
    return this.stateParams.accessMode !== 'create' && this.stateParams.manager === null;
  }

  private _getUserProfileInfo(successCallback) {
    const user = { userId: this.stateParams.userId };
    this.utilityService.getUserProfile(user).then((data) => {
      this.userObject = data;
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _populateForwardRecipientForView() {
    const forwardRecipientDetails = this.userProfile.userForwardRecipientDetails;
    if (forwardRecipientDetails != null && forwardRecipientDetails.forwardRecipient != null
      && forwardRecipientDetails.forwardRecipient.userId !== undefined) {
      const recipient = forwardRecipientDetails.forwardRecipient;
      recipient.ticked = true;
      const output = recipient.lastName != null ? (recipient.firstName + ' ' + recipient.lastName) : recipient.firstName;
      recipient.fullName = output.length > 57 ? (output.substring(0, 57) + '...') : output;
    }
  }

  private _getUserBelongsTo() {
    let managerUserId = '';
    let userId = '';
    if (this._isCreateUserUnderManager()) {
      managerUserId = this.managerDetails.userId;
    } else if (this.originalManagerObj) {
      managerUserId = this.originalManagerObj.userId;
      userId = this.userProfile.userDetails.userId;
    } else {
      userId = this.userProfile.userDetails.userId;
    }

    if (managerUserId === this.authService.getUserDetails().id) {
      managerUserId = '';
    }

    this.userService.getUserBelongsTo(this.companyId, managerUserId, userId, (data) => {
      this.buList = data.buInfos;
      if (data.belongsToCorp) {
        this.canAddUserAtCompanyLevel = true;
        this.canAddUserAtDepartmentOrBULevel = true;
      } else {
        this.canAddUserAtCompanyLevel = false;
        this.canAddUserAtDepartmentOrBULevel = true;
      }
      this._setBuName();
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _setBuName() {
    const bu = this.buList.filter((b) => this.userProfile.buId === b.id);
    if (this.userProfile.buId !== null && this.userProfile.buId !== '' && bu.length === 0) {
      const buObject = { id: this.userProfile.buId, name: this.userProfile.buName };
      this.buList.push(buObject);
      bu.push(buObject);
    }
    this.selectedBuName = bu.length > 0 ? bu[0].name : 'Corporate';
  }

  private _getRolesInTheCompany() {
    let managerId;
    if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
      managerId = this.managerDetails.roleId;
      this.userService.getUserCreateRoles(managerId, this.authService.getUserDetails().company.companyType, (data) => {
        this.roles = data;
        if (this.isInHost) {
          this.roles.forEach((role) => {
            if (role.name === this.MESSAGECONSTANTS.ROLES.FOURDOTFIVEADMIN) {
              this.userProfile.userDetails.role = role;
              this.userProfileReset.userDetails.role = role;
            }
          });
        } else if (this.isStaffingCompany || this.isCorporateCompany) {
          if (this.roles.length === 1) {
            this.userProfile.userDetails.role = this.roles[0];
            this.userProfileReset.userDetails.role = this.roles[0];
          } else if (this.roles.length > 1) {
            this.roles.forEach((role) => {
              if (role.name === this.MESSAGECONSTANTS.ROLES.RECRUITER) {
                this.userProfile.userDetails.role = _.cloneDeep(role);
                this.userProfileReset.userDetails.role = _.cloneDeep(role);
              }
            });
          }
        }

        if (!(this.roles.length === 1 && this.isCompanyAdmin(this.roles[0]))) {
          this.userProfile.userDetails.manager = this.managerDetails;
          this.userProfileReset.userDetails.manager = this.managerDetails;
        }
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    } else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
      this.isValidMobileNumberEntered = true;
      this.isValidWorkTelephoneEntered = true;
      const managerToGetRoles = this.storageService.get('managers');
      if (managerToGetRoles !== null && managerToGetRoles !== undefined && managerToGetRoles.length > 0) {
        managerId = managerToGetRoles[0].roleId;
      }

      if (this.isFourDotFiveAdmin(this.authService.getUserDetails().roleScreenRef.role) || this.isSuperUser(this.authService.getUserDetails().roleScreenRef.role)) {
        if (this.isFourDotFiveAdmin(this.authService.getUserDetails().roleScreenRef.role) && this.isFourDotFiveAdmin(this.userProfileReset.userDetails.role)) {
          this.roles = [this.userProfileReset.userDetails.role];
        } else {
          this.userService.getUserUpdateRoles(managerId, this.authService.getUserDetails().company.companyType, (data) => {
            this.roles = data;
          }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
          });
        }
      } else {
        if (this.userProfile.userDetails.manager !== null) {
          this.userService.getUserUpdateRoles(this.userProfileReset.userDetails.manager.roleId, this.authService.getUserDetails().company.companyType, (data) => {
            this.roles = data;
          }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
          });
        } else {
          this.roles.push(this.userProfile.userDetails.role);
        }
      }
      if (!this.isCompanyAdmin(this.userProfileReset.userDetails.role)) {
        this._getManagersList(this.userObject.userDetails.userId, this.userObject.userDetails.role.id, this.userObject.buId);
      } else {
        this.isLoading = false;
      }
    } else if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
      this.roles.push(this.userProfile.userDetails.role);
    }
  }

  private _getManagersList(userId, roleId, buId) {
    if (!(this.isCorporateFlag && !_.isNull(buId) && buId !== '' && buId !== undefined)) {
      buId = null;
    }
    this.userService.getManagers(userId, roleId, buId, (data) => {
      this.managerList = data;
      if (this.userProfile.userDetails.role.name === this.MESSAGECONSTANTS.ROLESNAMES.FOURDOTFIVEADMIN_NAME) {
        this.managerList.push(this.userProfile.userDetails.manager);
      }
      this.isLoading = false;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _setDepartment() {
    if (!_.isNull(this.userProfile.departmentId)) {
      this.selectedDepartmentObjectsArray.push({ id: this.userProfile.departmentId, name: this.userProfile.departmentName });
    }
  }

  onWorkTelephoneChanged(value) {
    this.userProfile.userDetails.workTelephone = value;
  }

  onMobileNumberChanged(value) {
    this.userProfile.userDetails.mobileNumber = value;
  }

  getZipCodeDetails(zipcode) {
    this._getAddressDetails(zipcode, 'zipchanged');
  }

  private _getAddressDetails(zipcode, type, callback?) {
    this.validzipcode = true;
    let locations = [];
    if (zipcode) {
      this.geocodingService.getByZipCode(zipcode).subscribe((data: any) => {
        if (data.status === 'OK') {
          locations = this._parseGeoLocations(data.results);
          if ((type === 'zipchanged' || type === 'copycomanyaddress') && locations.length) {
            this.userProfile.userDetails.city = locations[0].city;
            this.userProfile.userDetails.state = locations[0].state;
            this.userProfile.userDetails.county = locations[0].county;
            this.isCountyExists = locations[0].county != null;
            this.userProfile.userDetails.country = locations[0].country;
          }
        } else {
          this.validzipcode = false;
          locations = [];
          this.userProfile.userDetails.city = '';
          this.userProfile.userDetails.state = '';
          this.userProfile.userDetails.county = '';
          this.isCountyExists = false;
          this.userProfile.userDetails.country = '';
        }
        this.geoLocations = locations;
        if (!this.geoLocations.length) {
          this.validzipcode = false;
        }
        if (callback) {
          callback(this.geoLocations);
        }
      }, () => {
        this.validzipcode = false;
        this.geoLocations = [];
        this.isCountyExists = false;
        if (callback) {
          callback('error');
        }
      });
    } else {
      this.geoLocations = [];
      this.isCountyExists = false;
      if (callback) {
        callback('success');
      }
    }
  }

  private _parseGeoLocations(results) {
    return results
      .filter((result) => result.types[0] === 'postal_code')
      .map((result) => {
        const location = this.geocodingService.parseAddress(result);
        if (location.county === undefined) {
          location.county = null;
        }
        return location;
      });
  }

  changeAddressObject(type, value) {
    const match = this.geoLocationsCopy.find((location) => location[type] === value);
    if (match) {
      if (type !== 'city') { this.userProfile.userDetails.city = match.city; }
      if (type !== 'state') { this.userProfile.userDetails.state = match.state; }
      if (type !== 'country') { this.userProfile.userDetails.country = match.country; }
      if (type !== 'county') { this.userProfile.userDetails.county = match.county; }
      this.isCountyExists = match.county != null;
    }
  }

  toggleCopyCompanyAddress(checked) {
    if (checked) {
      this.companyService.getCompanyDetails(this.companyId, (data) => {
        this.userProfile.userDetails.address1 = data.company.address1;
        this.userProfile.userDetails.address2 = data.company.address2;
        this.userProfile.userDetails.zipcode = data.company.zipcode;
        this._getAddressDetails(data.company.zipcode, 'copycomanyaddress');
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    } else {
      this.userProfile.userDetails.address1 = this.userProfileReset.userDetails.address1;
      this.userProfile.userDetails.address2 = this.userProfileReset.userDetails.address2;
      this.userProfile.userDetails.zipcode = this.userProfileReset.userDetails.zipcode;
      this._getAddressDetails(this.userProfile.userDetails.zipcode, 'zipchanged');
    }
  }

  onUserBelongsToBUChanged() {
    const isBelongsToBUChangeValid = this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT
      || (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE && (this.nextButtonFlag > 0 || this.saveButtonFlag > 0));
    if (!isBelongsToBUChangeValid) {
      return;
    }
    if (this.userProfile.reporteeCount > 0) {
      const message = "All the users and employees in the hierarchy reporting to the user will also have their 'Belongs to BU' changed.<br> Do you wish to continue?";
      this.alertsAndNotificationsService.showConfirm('Confirm', message, 'warning', false,
        () => {
          this._setBuName();
          this._getManagersList(this.userProfile.userDetails.userId, this.userProfile.userDetails.role.id, this.userProfile.buId);
        }, () => {
          this.userProfile.buId = this.userProfileReset.buId;
        });
    } else {
      this._setBuName();
      this._getManagersList(this.userProfile.userDetails.userId, this.userProfile.userDetails.role.id, this.userProfile.buId);
    }
  }

  changeRoleObject() {
    const roleId = this.userProfile.userDetails.role.id;
    const matched = this.roles.find((role) => role.id === roleId);
    if (matched) {
      this.userProfile.userDetails.role = _.cloneDeep(matched);
    }
    const isRoleChangeValid = this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT
      || (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE && (this.nextButtonFlag > 0 || this.saveButtonFlag > 0));
    if (isRoleChangeValid && this.userProfile.userDetails.role.id !== this.userProfileReset.userDetails.role.id) {
      if (this.isCompanyAdmin(this.userProfileReset.userDetails.role)) {
        this.userProfile.userDetails.manager = null;
        let buId = null;
        if (this.isCorporateFlag && !_.isNull(this.userProfile.buId)
          && this.userProfile.buId !== '' && this.userProfile.buId !== undefined) {
          buId = this.userProfile.buId;
        }
        this.userService.getManagersWhileDemotingAdmin(
          this.userProfileReset.userDetails.userId, this.companyId, this.userProfile.userDetails.role.id, buId, (data) => {
          if (data.length === 0) {
            this._showRoleChangeAlert('Cannot change the role of the only existing Admin.');
          } else {
            this._checkRoleChange();
          }
        }, (error) => {
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
      } else {
        this._checkRoleChange();
      }
    } else if (isRoleChangeValid) {
      this._getManagersList(this.userProfile.userDetails.userId, this.userProfile.userDetails.role.id, this.userProfile.buId);
    }
  }

  private _checkRoleChange() {
    const resetRole = this.userProfileReset.userDetails.role;
    const currentRole = this.userProfile.userDetails.role;
    if (this.isSeniorRecruiter(resetRole) || this.isRecruiter(resetRole)) {
      this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
    } else if (this.userRoleService.isRecruitingManager(resetRole) || this.userRoleService.isHiringManager(resetRole)) {
      if (this.isRecruiter(currentRole) || this.isSeniorRecruiter(currentRole)) {
        if (this.userProfileReset.reporteeCount > 0) {
          this._showRoleChangeAlert(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_REPORTEES);
        } else if (this.userProfile.reporteeCount === 0) {
          this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
        }
      } else if (this.isCompanyAdmin(currentRole)) {
        if (this.userProfile.reporteeCount > 0) {
          this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CHANGE_MANAGER_TO_ADMIN_REPORTEES);
        } else {
          this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
        }
      }
    } else if (this.isCompanyAdmin(resetRole)) {
      if (this.isRecruiter(currentRole) || this.isSeniorRecruiter(currentRole)) {
        if (this.userProfileReset.reporteeCount > 0) {
          this._showRoleChangeAlert(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_REPORTEES);
        } else if (this.userProfile.reporteeCount === 0) {
          this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
        }
      } else if (this.userRoleService.isRecruitingManager(currentRole) || this.userRoleService.isHiringManager(currentRole)) {
        this._showRoleChangeConfirmation(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER_ALERT_WITH_NO_REPORTEES);
      }
    } else {
      this.alertsAndNotificationsService.showBannerMessage('Something went wrong! please try again later', 'danger');
    }
  }

  private _showRoleChangeAlert(message) {
    this.alertsAndNotificationsService.showAlertWithCallBack('Oh snap!', message, 'danger', () => {
      this.userProfile.userDetails.role = _.cloneDeep(this.userProfileReset.userDetails.role);
      if (this.userDetailsForm && this.userDetailsForm.controls.role) {
        this.userDetailsForm.controls.role.markAsPristine();
      }
    });
  }

  private _showRoleChangeConfirmation(message) {
    this.alertsAndNotificationsService.showConfirm('Warning', message, 'warning', true,
      () => {
        if (this.isCompanyAdmin(this.userProfileReset.userDetails.role)) {
          this.userProfile.userDetails.manager = null;
          this._getManagerListWhileDemotingAdmin(this.userProfile.userDetails.userId);
        } else {
          this._getManagersList(this.userProfile.userDetails.userId, this.userProfile.userDetails.role.id, this.userProfile.buId);
        }
      }, () => {
        this.userProfile.userDetails.role = _.cloneDeep(this.userProfileReset.userDetails.role);
        if (this.userDetailsForm && this.userDetailsForm.controls.role) {
          this.userDetailsForm.controls.role.markAsPristine();
        }
      });
  }

  private _getManagerListWhileDemotingAdmin(userId) {
    let buId = null;
    if (this.isCorporateFlag && !_.isNull(this.userProfile.buId) && this.userProfile.buId !== '' && this.userProfile.buId !== undefined) {
      buId = this.userProfile.buId;
    }
    this.userService.getManagersWhileDemotingAdmin(userId, this.companyId, this.userProfile.userDetails.role.id, buId, (data) => {
      if (data.length === 0) {
        this.alertsAndNotificationsService.showBannerMessage('Cannot change the role of the only existing Admin !', 'danger');
        this.userProfile.userDetails.role = _.cloneDeep(this.userProfileReset.userDetails.role);
        if (this.userScopeDetailsForm) {
          this.userScopeDetailsForm.form.markAsPristine();
        }
      } else {
        this.managerList = data;
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  changeManagerObject() {
    const message = this.userProfile.reporteeCount > 0
      ? this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CHANGE_MANAGER_REPORTEES
      : this.MESSAGECONSTANTS.NOTIFICATIONS.USER.CHANGE_MANAGER;
    const managerid = this.userProfile.userDetails.manager.userId;
    this.alertsAndNotificationsService.showConfirm('Warning', message, 'warning', false,
      () => {
        const matched = this.managerList.find((manager) => manager.userId === managerid);
        if (matched) {
          this.userProfile.userDetails.manager = _.cloneDeep(matched);
        }
      }, () => {
        this.userProfile.userDetails.manager = _.cloneDeep(this.userProfileReset.userDetails.manager);
      });
  }

  public getDepartments = (searchTerm: string): Observable<any[]> => {
    const searchObject = { searchText: searchTerm, companyId: this.companyId };
    return from(this.employeeService.getDepartmentsPromiseForTypeAhead(searchObject).then((data: any) => data as any[]));
  }

  departmentTypeAheadDepartmentAdded(tag) {
    this.userProfile.departmentName = tag.name;
    if (tag.id !== undefined) {
      this.userProfile.departmentId = tag.id;
    }
  }

  departmentTypeAheadDepartmentRemoved() {
    this.userProfile.departmentId = null;
    this.userProfile.departmentName = null;
  }

  getFullName(firstName, lastName) {
    return this.utilityService.getFullName(firstName, lastName);
  }

  handleLongName(longName, limitToMax) {
    return this.utilityService.handleLongName(longName, limitToMax);
  }

  isLoggedInUser(userDetails) {
    return userDetails.userId === this.authService.getUserDetails().id;
  }

  isSuperUser(role) {
    return this.userRoleService.isSuperUser(role);
  }

  isFourDotFiveAdmin(role) {
    return this.userRoleService.isFourDotFiveAdmin(role);
  }

  isCompanyAdmin(role) {
    return role.id === this.MESSAGECONSTANTS.ROLEIDS.STAFFING_ADMIN || role.id === this.MESSAGECONSTANTS.ROLEIDS.CORPORATE_ADMIN;
  }

  isSeniorRecruiter(role) {
    return this.userRoleService.isSeniorRecruiter(role);
  }

  isRecruiter(role) {
    return this.userRoleService.isRecruiter(role);
  }

  isLoggedInUserRecruiterOrSeniorRecruiter() {
    const loggedInUserRole = this.authService.getUserDetails().roleScreenRef.role;
    return this.isSeniorRecruiter(loggedInUserRole) || this.isRecruiter(loggedInUserRole);
  }

  // TODO(Step 5): userScopeDetails is currently populated only by _getEntityScopeDetails(),
  // called from the Next-button/wizard-navigation flow ported in Step 5. Until then this runs
  // against whatever userScopeDetails already came back on userProfile (edit/view) or stays empty.
  private _parseRoleScopeDetails() {
    this.showClientList = !this.userProfile.userScopeDetails.allclientOrBU
      || (this.userProfile.userScopeDetails.allclientOrBU && !this.userProfile.userScopeDetails.userClientBUinfo.hasAllBuOrClientEnabledForParent);
    this.showBuList = !this.userProfile.userScopeDetails.allBusOfClient
      || (this.userProfile.userScopeDetails.allBusOfClient && !this.userProfile.userScopeDetails.userClientBUinfo.hasAllBuOfClientEnabledForParent);
  }

  onClientOrBuSelection(clientOrBu) {
    if (!clientOrBu.enabled) {
      this.userService.checkIfUserHasRequisitionsInClientOrBu(this.companyId, this.userProfile.userDetails.userId, clientOrBu.id, (data) => {
        if (data) {
          clientOrBu.enabled = !clientOrBu.enabled;
          const clientOrBULabel = this.isStaffingCompany ? 'Client' : 'BU';
          this._showClientOrBuCannotBeRemovedMessage(clientOrBULabel);
        } else if (!clientOrBu.enabled && clientOrBu.subordinatesBelongToBu) {
          clientOrBu.enabled = !clientOrBu.enabled;
          this._showClientOrBuUncheckableWarning(clientOrBu);
        }
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }
  }

  onClientsBuSelection(bu) {
    if (!bu.enabled) {
      this.userService.checkIfUserHasRequisitionsInClientOrBu(this.companyId, this.userProfile.userDetails.userId, bu.buId, (data) => {
        if (data) {
          bu.enabled = !bu.enabled;
          this._showClientOrBuCannotBeRemovedMessage('Client\'s BU');
        }
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }
  }

  private _showClientOrBuCannotBeRemovedMessage(clientOrBULabel) {
    const title = clientOrBULabel + ' cannot be removed';
    const message = 'This ' + clientOrBULabel + ' cannot be removed as there are requisitions under this user that are associated with this ' + clientOrBULabel + '.';
    this.alertsAndNotificationsService.showAlert(title, message, 'warning');
  }

  private _showClientOrBuUncheckableWarning(clientOrBu) {
    this.addEditUserActionsModalService.show({
      userId: this.userProfile.userDetails.userId,
      buId: clientOrBu.id,
      isCorporate: this.isCorporateFlag
    });
  }

  // Wizard navigation (fuelux drives the visual step change; we hold it with
  // evt.preventDefault() until the async validate/save/scope-fetch finishes,
  // then call wizardEl.wizard('next') ourselves - same pattern as
  // edit-shared-req-page's _onWizardActionClicked).
  private _onWizardActionClicked(evt: any, data: any) {
    if (data.direction === 'previous') {
      this.saveButtonClicked = false;
      this.nextButtonClicked = false;
      this.lastStep = false;
      if (data.step === 2) {
        this.storageService.set('wizardoperations', true, null);
      }
      return;
    }
    if (data.step !== 1) {
      return;
    }
    if (this.wizardAdvancePending) {
      this.wizardAdvancePending = false;
      return;
    }
    evt.preventDefault();
    this._onNextFromStep1();
  }

  private _onWizardFinished() {
    if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
      this._navigateAwayFromWizard();
      return;
    }
    this.formSubmitted = true;
    this.nextButtonClicked = true;
    if (this.userDetailsForm) { this.userDetailsForm.onSubmit(undefined); }
    if (this.userScopeDetailsForm) { this.userScopeDetailsForm.onSubmit(undefined); }
    this.valid = !!this.userDetailsForm && this.userDetailsForm.valid
      && !!this.userScopeDetailsForm && this.userScopeDetailsForm.valid
      && this.isValidMobileNumberEntered && this.isValidWorkTelephoneEntered;
    if (!this.valid) {
      this.formSubmitted = false;
      this.nextButtonClicked = false;
      return;
    }
    if (!this._hasStepDataChanged(2)) {
      this._reportUserSavedAndNavigate();
    } else {
      this._manageUserScopeDetails();
    }
  }

  private _onNextFromStep1() {
    this.formSubmitted = true;
    this.nextButtonClicked = true;
    if (this.userDetailsForm) { this.userDetailsForm.onSubmit(undefined); }
    this.valid = this._isStep1Valid();
    if (!this.valid) {
      this.formSubmitted = false;
      this.nextButtonClicked = false;
      return;
    }
    if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.VIEW) {
      this._getEntityScopeDetailsAndAdvance();
      return;
    }
    if (this._hasStepDataChanged(1)) {
      const url = this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE
        ? this.USERMANAGEMENTCONSTANTS.CONTROLLER.SAVE_USER + '/' + this.companyId
        : this.USERMANAGEMENTCONSTANTS.CONTROLLER.UPDATE_USER + '/' + this.companyId;
      this._manageUserDetailsAndAdvance(url);
    } else {
      this._getEntityScopeDetailsAndAdvance();
    }
  }

  private _isStep1Valid(): boolean {
    return !!this.userDetailsForm && this.userDetailsForm.valid
      && !this.utilityService.isContentinObjSame(this.userProfile.userDetails.address1, this.userProfile.userDetails.address2)
      && this.isValidMobileNumberEntered && this.isValidWorkTelephoneEntered;
  }

  private _hasStepDataChanged(currentStep: number): boolean {
    if (currentStep === 1) {
      return !_.isEqual(this.userProfile, this.userProfileReset) && !!this.userDetailsForm && this.userDetailsForm.dirty;
    }
    if (currentStep === 2) {
      return !_.isEqual(this.userProfile.userScopeDetails, this.userProfileReset.userScopeDetails);
    }
    return false;
  }

  private _manageUserDetailsAndAdvance(url: string) {
    const roleOrManagerChangeCheck = this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT
      || (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE && (this.nextButtonFlag > 0 || this.saveButtonFlag > 0));
    if (roleOrManagerChangeCheck) {
      this._getChangesForRoleAndManager();
    }
    this.utilityService.saveUserProfileObject(url, _.cloneDeep(this.userProfile)).then((data) => {
      this.formSubmitted = false;
      this.userProfile = data;
      this.nextButtonFlag++;
      this.recentButtonClick = 'nextButton';
      this.nextButtonClicked = false;
      this._showUserDetailsSaveMessage('next');
      this.geoLocationsCopy = _.cloneDeep(this.geoLocations);
      this.userProfileReset = _.cloneDeep(this.userProfile);
      if (this.userDetailsForm) { this.userDetailsForm.form.markAsPristine(); }
      this._getEntityScopeDetailsAndAdvance();
    }, (error) => {
      this.formSubmitted = false;
      this.nextButtonClicked = false;
      if (error.statusCode === '410') {
        this._handleUserAlreadyProcessed();
      } else {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        if (this._isRoleExistsforUser() && this._isManagerExistsforUser()) {
          this.userProfile.userDetails = _.cloneDeep(this.userProfileReset.userDetails);
        }
      }
    });
  }

  private _handleUserAlreadyProcessed() {
    let managerReturnObj;
    if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
      if (this.managerDetails != null && this.managerDetails.lastName != null) {
        this.managerDetails.firstName = this.managerDetails.firstName.split(' ')[0];
      }
      managerReturnObj = this.managerDetails;
    } else {
      managerReturnObj = this.originalManagerObj;
    }
    this.storageService.remove('wizardoperations');
    if (this.stateParams.purpose != null) {
      this.$state.go('missioncontrol.dashboard', null, { reload: true });
    } else {
      this.$state.go('missioncontrol.teamMembers', { managerObj: managerReturnObj }, { reload: false });
    }
  }

  private _isRoleExistsforUser(): boolean {
    return this.userProfile.userDetails != null && this.userProfileReset.userDetails != null
      && this.userProfile.userDetails.role != null && this.userProfileReset.userDetails.role != null;
  }

  private _isManagerExistsforUser(): boolean {
    return this._isRoleExistsforUser()
      && this.userProfile.userDetails.manager !== undefined && this.userProfileReset.userDetails.manager !== undefined;
  }

  private _getChangesForRoleAndManager() {
    if (!_.isEqual(this.userProfile.userDetails.role, this.userProfileReset.userDetails.role)) {
      this.roleChanged = true;
      this.oldRole = _.cloneDeep(this.userProfileReset.userDetails.role);
    } else {
      this.roleChanged = false;
      this.oldRole = null;
    }
    if (!_.isEqual(this.userProfile.userDetails.manager, this.userProfileReset.userDetails.manager)) {
      this.managerChanged = true;
      this.oldManager = _.cloneDeep(this.userProfileReset.userDetails.manager);
    } else {
      this.managerChanged = false;
      this.oldManager = null;
    }
  }

  private _showUserDetailsSaveMessage(buttonClicked: string) {
    const userDetailsSaveMessageCheck = this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT
      || (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE && (this.nextButtonFlag > 0 || this.saveButtonFlag > 0));
    if (!userDetailsSaveMessageCheck) {
      return;
    }
    const userFullName = this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName);
    const newRoleDescription = this.userProfile.userDetails.role.description;
    if (this.roleChanged && this.managerChanged) {
      const newManagerName = this.getFullName(this.userProfile.userDetails.manager.firstName, null);
      const managerLabel = this.isCompanyAdmin(this.userProfileReset.userDetails.role)
        ? 'has been set to'
        : `was changed from '<b><i class='wrap-word'>${this.getFullName(this.oldManager.firstName, null)}</i></b>' to`;
      const message = `The role for the user '<b><i class='wrap-word'>${userFullName}</i></b>' was successfully changed`
        + ` from '<b><i class='wrap-word'>${this.oldRole.description}</i></b>' to '<b><i class='wrap-word'>${newRoleDescription}</i></b>'`
        + ` <br> The manager of the user '<b><i class='wrap-word'>${userFullName}</i></b>' ${managerLabel}`
        + ` '<b><i class='wrap-word'>${newManagerName}</i></b>'.`;
      this.alertsAndNotificationsService.showBannerMessage(message, 'success');
    } else if (this.roleChanged) {
      const message = `The role for the user '<b><i class='wrap-word'>${userFullName}</i></b>' was successfully changed`
        + ` from '<b><i class='wrap-word'>${this.oldRole.description}</i></b>' to '<b><i class='wrap-word'>${newRoleDescription}'.`;
      this.alertsAndNotificationsService.showBannerMessage(message, 'success');
    } else if (this.managerChanged) {
      const oldManagerName = this.getFullName(this.oldManager.firstName, null);
      const newManagerName = this.getFullName(this.userProfile.userDetails.manager.firstName, null);
      const message = `The manager of the user '<b><i class='wrap-word'>${userFullName}</i></b>' was changed`
        + ` from '<b><i class='wrap-word'>${oldManagerName}</i></b>' to '<b><i class='wrap-word'>${newManagerName}</i></b>'.`;
      this.alertsAndNotificationsService.showBannerMessage(message, 'success');
    } else if (buttonClicked === 'save') {
      if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
        const key = this.userCreated ? 'SAVESUCCESS' : 'CREATESUCCESS';
        this.alertsAndNotificationsService.showBannerMessage(this._userMessage(key), 'success');
      } else if (this.isLoggedInUser(this.userProfile.userDetails)) {
        this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.OWN_PROFILE_UPDATE, 'success');
      } else {
        this.alertsAndNotificationsService.showBannerMessage(this._userMessage('UPDATESUCCESS'), 'success');
      }
    }
  }

  private _userMessage(key: string): string {
    const userFullName = this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName);
    return `${this.MESSAGECONSTANTS.NOTIFICATIONS.USER.USER} '<b><i class='wrap-word'>${userFullName}</i></b>' `
      + this.MESSAGECONSTANTS.NOTIFICATIONS.USER[key];
  }

  private _getEntityScopeDetailsAndAdvance() {
    if (this.isInHost) {
      const role = _.cloneDeep(this.userProfile.userDetails.role);
      const userId = _.cloneDeep(this.userProfile.userDetails.userId);
      this.utilityService.getCompaniesforUser(role, userId, 0, 10000, 'name', 'asc').then((data) => {
        this.userProfile.userScopeDetails = data;
        this.userProfileReset.userScopeDetails = _.cloneDeep(this.userProfile.userScopeDetails);
        this._advanceToStep2();
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        this._resetNextButtonState();
      });
    } else if (this.isFourDotFiveAdmin(this.userProfile.userDetails.role)) {
      this.userProfile.userScopeDetails = this._createEntityScopeForAdmin();
      this.userProfileReset.userScopeDetails = _.cloneDeep(this.userProfile.userScopeDetails);
      this._advanceToStep2();
    } else {
      this.utilityService.getUserRoleEntityScope(_.cloneDeep(this.userProfile)).then((data) => {
        this.userProfile.userScopeDetails = data;
        this._parseRoleScopeDetails();
        this.userProfileReset.userScopeDetails = _.cloneDeep(this.userProfile.userScopeDetails);
        this._advanceToStep2();
      }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        this._resetNextButtonState();
      });
    }
  }

  private _createEntityScopeForAdmin() {
    const entityObj: any = {
      allIndustries: true,
      allJobRequisitionTitleList: true,
      allclientOrBU: true,
      allBusOfClient: true,
      requisitionCategory: false,
      requisitionCategoryList: []
    };
    const companyTypes = this.MESSAGECONSTANTS.COMPANY_TYPES;
    if (this.companyType === companyTypes.STAFFING || this.companyType === companyTypes.CORPORATE) {
      entityObj.requisitionCategoryList = [
        { name: 'Retained', isSelected: true },
        { name: 'Contingent', isSelected: true },
        { name: 'Both', isSelected: true }
      ];
    }
    return entityObj;
  }

  private _advanceToStep2() {
    this.lastStep = true;
    this._resetNextButtonState();
    this.wizardAdvancePending = true;
    this.wizardEl.wizard('next');
  }

  private _resetNextButtonState() {
    this.formSubmitted = false;
    this.nextButtonClicked = false;
  }

  private _reportUserSavedAndNavigate() {
    let managerReturnObj;
    if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
      if (!this.userCreated) {
        this.userCreated = true;
        if (this.nextButtonFlag > 0 && this.recentButtonClick === 'nextButton') {
          this.alertsAndNotificationsService.showBannerMessage(this._userMessage('CREATESUCCESS'), 'success');
        }
      } else if (this.nextButtonFlag > 0 && this.recentButtonClick === 'nextButton') {
        this.alertsAndNotificationsService.showBannerMessage(this._userMessage('SAVESUCCESS'), 'success');
      }
      this.managerDetails.firstName = this.managerDetails.firstName.split(' ')[0];
      managerReturnObj = this.managerDetails;
    } else {
      if (this.nextButtonFlag > 0 && this.recentButtonClick === 'nextButton') {
        this.alertsAndNotificationsService.showBannerMessage(this._userMessage('UPDATESUCCESS'), 'success');
      } else {
        const userFullName = this.getFullName(this.userProfile.userDetails.firstName, this.userProfile.userDetails.lastName);
        const message = `${this.MESSAGECONSTANTS.NOTIFICATIONS.USER.NOTHING_UPDATED} '<b><i class='wrap-word'>${userFullName}</i></b>' `;
        this.alertsAndNotificationsService.showBannerMessage(message, 'success');
      }
      managerReturnObj = this.originalManagerObj;
    }
    this.storageService.remove('wizardoperations');
    if (this.stateParams.purpose != null) {
      this.$state.go('missioncontrol.dashboard', null, { reload: true });
    } else {
      this.$state.go('missioncontrol.teamMembers', { managerObj: managerReturnObj }, { reload: false });
    }
  }

  private _manageUserScopeDetails() {
    this.utilityService.setUserRoleEntityScope(_.cloneDeep(this.userProfile)).then((data) => {
      this.userProfile = data;
      this.nextButtonFlag++;
      this.recentButtonClick = 'nextButton';
      this.nextButtonClicked = false;
      this.userProfileReset = _.cloneDeep(this.userProfile);
      if (this.userScopeDetailsForm) { this.userScopeDetailsForm.form.markAsPristine(); }
      let managerReturnObj;
      if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE) {
        const key = this.userCreated ? 'SAVESUCCESS' : 'CREATESUCCESS';
        this.userCreated = true;
        this.alertsAndNotificationsService.showBannerMessage(this._userMessage(key), 'success');
        this.managerDetails.firstName = this.managerDetails.firstName.split(' ')[0];
        managerReturnObj = this.managerDetails;
      } else {
        if (this.stateParams.purpose != null) {
          this.storageService.remove('wizardoperations');
          this.$state.go('missioncontrol.dashboard', null, { reload: true });
          this.userService.userCache(null, () => { }, () => { });
          return;
        }
        this.alertsAndNotificationsService.showBannerMessage(this._userMessage('UPDATESUCCESS'), 'success');
        managerReturnObj = this.originalManagerObj;
      }
      this.storageService.remove('wizardoperations');
      this.$state.go('missioncontrol.teamMembers', { managerObj: managerReturnObj }, { reload: false });
      this.userService.userCache(null, () => { }, () => { });
    }, (error) => {
      this.formSubmitted = false;
      this.nextButtonClicked = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      this.userProfile.userScopeDetails = _.cloneDeep(this.userProfileReset.userScopeDetails);
    });
  }

  private _navigateAwayFromWizard() {
    this.storageService.remove('wizardoperations');
    if (this.stateParams.purpose != null) {
      this.$state.go('missioncontrol.dashboard', null, { reload: true });
    } else {
      this._goToUsersPage();
    }
  }

  /**
   * This method will be called whenever user clicks the 'SAVE' button.
   * It checks whether any changes are made in the UI for the current step.
   */
  saveStepData() {
    this.formSubmitted = true;
    this.nextButtonClicked = false;
    const currentStep = this._getCurrentWizardStep();
    if (currentStep === 1) {
      this._saveStep1();
    } else if (currentStep === 2) {
      this._saveStep2();
    }
  }

  private _saveStep1() {
    if (this.userDetailsForm) { this.userDetailsForm.onSubmit(undefined); }
    this.valid = this._isStep1Valid();
    if (this.valid && !this._hasStepDataChanged(1)) {
      this.formSubmitted = false;
      this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
    } else if (this.valid) {
      const url = this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE
        ? this.USERMANAGEMENTCONSTANTS.CONTROLLER.SAVE_USER + '/' + this.companyId
        : this.USERMANAGEMENTCONSTANTS.CONTROLLER.UPDATE_USER + '/' + this.companyId;
      this._saveUserDetails(url);
    } else {
      this.formSubmitted = false;
    }
  }

  private _saveUserDetails(url: string) {
    const roleOrManagerChangeCheck = this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT
      || (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE && (this.nextButtonFlag > 0 || this.saveButtonFlag > 0));
    if (roleOrManagerChangeCheck) {
      this._getChangesForRoleAndManager();
    }
    this.utilityService.saveUserProfileObject(url, _.cloneDeep(this.userProfile)).then((data) => {
      this.formSubmitted = false;
      this.userProfile = data;
      this.saveButtonFlag++;
      this.recentButtonClick = 'saveButton';
      this._showUserDetailsSaveMessage('save');
      this.geoLocationsCopy = _.cloneDeep(this.geoLocations);
      this.userProfileReset = _.cloneDeep(this.userProfile);
      this.userCreated = this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.CREATE;
      if (this.userDetailsForm) { this.userDetailsForm.form.markAsPristine(); }
    }, (error) => {
      this.formSubmitted = false;
      if (error.statusCode === '410') {
        this._handleUserAlreadyProcessed();
      } else {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        if (this._isRoleExistsforUser() && this._isManagerExistsforUser()) {
          this.userProfile.userDetails = _.cloneDeep(this.userProfileReset.userDetails);
        }
      }
    });
  }

  private _saveStep2() {
    if (this.userScopeDetailsForm) { this.userScopeDetailsForm.onSubmit(undefined); }
    this.valid = !!this.userDetailsForm && this.userDetailsForm.valid
      && !!this.userScopeDetailsForm && this.userScopeDetailsForm.valid
      && this.isValidMobileNumberEntered && this.isValidWorkTelephoneEntered;
    if (this.valid && !this._hasStepDataChanged(2)) {
      this.formSubmitted = false;
      this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
    } else if (this.valid) {
      this._saveUserScopeDetails();
    } else {
      this.formSubmitted = false;
    }
  }

  private _saveUserScopeDetails() {
    this.utilityService.setUserRoleEntityScope(_.cloneDeep(this.userProfile)).then((data) => {
      this.userProfile = _.cloneDeep(data);
      this.saveButtonFlag++;
      this.recentButtonClick = 'saveButton';
      this.userProfileReset = _.cloneDeep(this.userProfile);
      if (this.userScopeDetailsForm) { this.userScopeDetailsForm.form.markAsPristine(); }
      if (this.accessMode === this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
        if (this.isLoggedInUser(this.userProfile.userDetails)) {
          this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.USER.OWN_PROFILE_UPDATE, 'success');
        } else {
          this.alertsAndNotificationsService.showBannerMessage(this._userMessage('UPDATESUCCESS'), 'success');
        }
      } else {
        this.alertsAndNotificationsService.showBannerMessage(this._userMessage('SAVESUCCESS'), 'success');
      }
      this.roleChanged = false;
      this.managerChanged = false;
      this.userService.userCache(null, () => { }, () => { });
    }, (error) => {
      this.formSubmitted = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      this.userProfile.userScopeDetails = _.cloneDeep(this.userProfileReset.userScopeDetails);
    });
  }

  /**
   * This method is called when the user clicks 'Cancel'.
   */
  cancel() {
    const currentStep = this._getCurrentWizardStep();
    if (this._hasStepDataChanged(currentStep)) {
      const message = 'Unsaved data on the page will be lost. Do you still want to continue?';
      this.alertsAndNotificationsService.showConfirm('Warning!', message, 'warning', true,
        () => {
          this.clearData(currentStep);
          this._goToUsersPage();
        }, () => { });
    } else {
      this._goToUsersPage();
    }
  }

  cancelSteps() {
    this.cancel();
  }

  private _goToUsersPage() {
    const managers = this.storageService.get('managers');
    if (managers !== null && managers !== undefined && managers.length > 0) {
      this.$state.go('missioncontrol.teamMembers', { managerObj: managers[managers.length - 1] }, { reload: false });
    } else {
      this.$state.go('missioncontrol.teamMembers', { reload: true });
    }
  }

  private clearData(currentStep: number) {
    this.userProfile = _.cloneDeep(this.userProfileReset);
    if (currentStep === 1) {
      if (!_.isEqual(this.userProfile.userDetails.zipcode, this.userProfileReset.userDetails.zipcode)) {
        this._getAddressDetails(this.userProfileReset.userDetails.zipcode, 'zipchanged');
      } else {
        this._getAddressDetails(this.userProfileReset.userDetails.zipcode, 'start');
      }
      if (this.userProfile.userDetails.userId && this.userProfile.userDetails.role) {
        this._getManagersList(this.userProfile.userDetails.userId, this.userProfile.userDetails.role.id, this.userProfile.buId);
      }
      if (this.userDetailsForm) {
        this.userDetailsForm.form.markAsPristine();
        this.userDetailsForm.form.markAsUntouched();
      }
    } else if (currentStep === 2 && this.userScopeDetailsForm) {
      this.userScopeDetailsForm.form.markAsPristine();
    }
  }

  /**
   * This method is called when the user clicks directly on a step's name.
   */
  getStepChanges(stepClicked: number) {
    this.nextButtonClicked = false;
    this.lastStep = stepClicked === 2;
  }

  private _getCurrentWizardStep(): number {
    return this.wizardEl ? this.wizardEl.wizard('selectedItem').step : 1;
  }

  uiCanExit(transitions: any) {
    const toState = transitions.to().name;
    const toParams = transitions.params();
    const currentStep = this._getCurrentWizardStep();
    if (this.accessMode !== this.MESSAGECONSTANTS.ACCESS_MODES.VIEW
      && this._hasStepDataChanged(currentStep) && this.isTransitionAbortRequired && toState !== 'login') {
      transitions.abort();
      const message = 'Unsaved data on the page will be lost. Do you still want to continue?';
      this.alertsAndNotificationsService.showConfirm('Warning!', message, 'warning', true, () => {
        this.ngZone.run(() => {
          this.isTransitionAbortRequired = false;
          this.clearData(currentStep);
          this.storageService.remove('wizardoperations');
          if (this.authService.isSwitchClicked) {
            this.authService.setIsSwitchClicked(false);
            this.uibModalService.showAllCompanies();
          } else {
            this.$state.go(toState, toParams, { reload: true });
          }
        });
      }, () => {
        this.ngZone.run(() => {
          if (this.authService.isSwitchClicked) {
            this.authService.setIsSwitchClicked(false);
          }
        });
      });
    } else if (this.authService.isSwitchClicked && !this._hasStepDataChanged(currentStep)) {
      transitions.abort();
      setTimeout(() => this.uibModalService.showAllCompanies(), 150);
      this.authService.setIsSwitchClicked(false);
    }
  }
}
